import { Component, Input } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseQuery } from '../../../core/queries/base.query';
import { PaginatedQuery } from '../../../core/queries/pagination.query';
import { Paginator } from '../../models/paginator.model';
import { convertQueryToQueryParams } from '../../utils/query-params.utils';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  @Input({ required: true }) paginator!: Paginator;

  @Input() query: BaseQuery = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  handlePageEvent(event: PageEvent): void {
    this.paginator.pageIndex = event.pageIndex;
    this.paginator.pageSize = event.pageSize;

    const query: PaginatedQuery = { ...this.query, ...this.paginator.paginatedQuery };
    const queryParams = convertQueryToQueryParams(query);
    this.router.navigate([], { relativeTo: this.route, queryParams, preserveFragment: true });
  }
}
